import { Instance, types } from 'mobx-state-tree'
import GlobalComponentsStateModel from './GlobalComponentsStateModel'

const UIStateModel = types
  .model({
    error: types.maybeNull(types.map(types.frozen())),
    isLoading: types.optional(types.boolean, false),
    globalComponents: types.optional(GlobalComponentsStateModel, {
      Snackbar: {},
      Overlay: {},
    }),
    hasSeenFeatureIndicator: types.optional(types.boolean, false),
  })
  .actions((self) => {
    const sawFeatureIndicator = () => {
      self.hasSeenFeatureIndicator = true
    }

    return { sawFeatureIndicator }
  })

export default UIStateModel
export type UIStateModelType = Instance<typeof UIStateModel>
